import {RangeDatePickerProps} from '@gwc/main'
import {useQueryState} from '@yandex-delivery/utils'
import {memo, useCallback, useMemo} from 'react'

import {RangeDatePicker} from './DatePicker'
import {QuerySyncedRangeDatePickerProps} from './types'

export const QuerySyncedRangeDatePicker = memo(function QuerySyncedRangeDatePickerv2({
  queryName = {start: 'dateFrom', end: 'dateTo'},
  ...props
}: QuerySyncedRangeDatePickerProps) {
  const [dateFrom, setDateFrom] = useQueryState(queryName.start)
  const [dateTo, setDateTo] = useQueryState(queryName.end)

  const dateValue = useMemo(
    () => (!!dateFrom && !!dateTo && {start: dateFrom, end: dateTo}) || null,
    [dateFrom, dateTo],
  )
  const handleChange: RangeDatePickerProps['onChange'] = useCallback(
    newValue => {
      setDateFrom(newValue?.start || null)
      setDateTo(newValue?.end || null)
    },
    [setDateFrom, setDateTo],
  )

  return <RangeDatePicker {...props} onChange={handleChange} value={dateValue} />
})
